var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.25 54.25V7.75M7.75 54.25V7.75M23.25 20.6667V41.3333C23.25 43.7407 23.25 44.9444 23.6433 45.8939C24.1677 47.1598 25.1735 48.1657 26.4395 48.69C27.389 49.0833 28.5926 49.0833 31 49.0833C33.4074 49.0833 34.611 49.0833 35.5605 48.69C36.8265 48.1657 37.8323 47.1598 38.3567 45.8939C38.75 44.9444 38.75 43.7407 38.75 41.3333V20.6667C38.75 18.2593 38.75 17.0556 38.3567 16.1061C37.8323 14.8402 36.8265 13.8343 35.5605 13.31C34.611 12.9167 33.4074 12.9167 31 12.9167C28.5926 12.9167 27.389 12.9167 26.4395 13.31C25.1735 13.8343 24.1677 14.8402 23.6433 16.1061C23.25 17.0556 23.25 18.2593 23.25 20.6667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.5ab82e5b85ab29ad6821ce2a1090c9d4.svg";
export { ForwardRef as ReactComponent };